import ActionTypes from '../constants/actionTypes';
import queryProducts from '../utils/queryProducts';
import PRODUCT_CODES from '../constants/productCodes';

function update(response) {
  return {
    type: ActionTypes.UPDATE[PRODUCT_CODES.PRODUCTS],
    payload: response.data,
  };
}

function broadcastError(err) {
  return {
    type: ActionTypes.FAILED2FETCH[PRODUCT_CODES.PRODUCTS],
    payload: err
  };
}

function request(requestedFacet) {
  return {
    type: ActionTypes.REQUEST[PRODUCT_CODES.PRODUCTS]
  };
}

export default inputs => {
  return function(dispatch) {
    dispatch(request());

    return queryProducts(inputs)
      .then(response => {
        dispatch(update(response));
      })
      .catch(error => {
        dispatch(broadcastError(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/fetch_products.js